import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../../resources/auth/authentication.service';
import { CustomerService } from '../../resources/auth/customer.service';
import { PermissionService } from '../../resources/auth/permission.service';
import { Permission } from '../../resources/models/permission.enum';

@Injectable()
export class DefaultRouteGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private permissionService: PermissionService,
    private customerService: CustomerService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    Observable.forkJoin(
      this.permissionService.hasPermission(Permission.ACCESS_DASHBOARD).take(1),
      this.customerService.customers.take(1),
    ).subscribe(([canAccessDashboard, customers]) => {
      if (canAccessDashboard) {
        this.router.navigate(['/dashboard', 'dev']);
      } else {
        if (customers.length === 1) {
          this.router.navigate(['/client', customers[0].name, 'products']);
        } else if (customers.length > 1) {
          this.router.navigate(['/client', customers[0].name, 'products']);
        } else {
          this.router.navigate(['/not_implemented']);
        }
      }
    });
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/routing/default-route.guard.ts